export default function GalleryCategoryForm({ formId, data, setData, onSubmit, saving }) {
  const handleChange = ({ target: { name, value } }) =>
    setData((current) => ({ ...current, [name]: value }));
  return (
    <form id={formId} onSubmit={onSubmit}>
      <div className="add-content-wrap"><div className="row">
        <div className="col-lg-6"><div className="add-page-inputs">
          <div className="label-wrap-add"><label>Category Name<small>*</small></label></div>
          <input className="form-control" name="name" value={data.name}
            onChange={handleChange} placeholder="Enter Category Name" disabled={saving} />
        </div></div>
        <div className="col-lg-6"><div className="add-page-inputs">
          <div className="label-wrap-add"><label>Status</label></div>
          <select className="form-control" name="status" value={data.status}
            onChange={handleChange} disabled={saving}>
            <option value="0">Enabled</option><option value="1">Disabled</option>
          </select>
        </div></div>
      </div></div>
    </form>
  );
}
